function EncodeBase64UrlSafe(str) {
    // Convert to UTF-8 bytes
    const utf8Bytes = new TextEncoder().encode(str);

    // Convert bytes to regular base64
    let base64 = btoa(String.fromCharCode(...utf8Bytes));

    // Convert to URL-safe base64
    base64 = base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

    return base64;
}


function DecodeBase64UrlSafe(base64UrlString) {
    if (!base64UrlString) return "";

    // Step 1: Convert URL-safe chars back to standard Base64
    let base64 = base64UrlString.replace(/-/g, "+").replace(/_/g, "/");

    // Step 2: Pad with '=' if missing
    while (base64.length % 4) {
        base64 += "=";
    }

    // Step 3: Decode Base64 to a byte array
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

    // Step 4: Convert UTF-8 bytes back to a string
    return new TextDecoder("utf-8").decode(bytes);
}


export {
    EncodeBase64UrlSafe,
    DecodeBase64UrlSafe
}